import { createGlobalStyle } from "styled-components";

import danaRegular from "./danaRegular.woff2";

export default createGlobalStyle`
    @font-face {
        font-family: 'danaRegular';
        src: local('danaRegular'), local('danaRegular'),
        url(${danaRegular}) format('woff2'),
        url(${danaRegular}) format('woff');
        font-weight: 300;
        font-style: normal;
    }
`;
